import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=c3bb70a6&scoped=true"
import script from "./recharge.vue?vue&type=script&lang=js"
export * from "./recharge.vue?vue&type=script&lang=js"
import style0 from "./recharge.vue?vue&type=style&index=0&id=c3bb70a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bb70a6",
  null
  
)

export default component.exports